<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />

<div class="container-fluid gx-5">
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'ballot-check']"></fa-icon> Project Tracker
        </h3>
      </div>

      <div class="bg-light p-2 rounded-lg rounded-2">
        <form class="k-form-horizontal">
          <div class="row g-3 align-items-center">
            <div class="col-4 k-form-field">
              <label class="form-label col-1 k-label">Project</label>
              <div style="width: 100%;">
                <kendo-dropdownlist [data]="projects" [(value)]="currentProject" textField="project_name"
                  valueField="id" (valueChange)="projectValueChange($event)"
                  [defaultItem]="defaultProjectItem"></kendo-dropdownlist>
              </div>
            </div>
          </div>
        </form>
      </div>
      <casi-searcher [projects]="projects" [projectLabels]="projectLabels" [users]="users"
        [storyEstimates]="storyEstimates" [storyPriorities]="storyPriorities" [storyTypes]="storyTypes"
        (onSearch)="onSearch($event)" [searchOptions]="searchOptions"></casi-searcher>
      <kendo-tabstrip [tabAlignment]="'stretched'" (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab *ngFor="let item of tabItems; let i = index" [title]="item.name"
          [selected]="i === selectedTab">
          <ng-template kendoTabContent>
            <casi-project-grid [projectLabels]="projectLabels" [searchOptions]="searchOptions" [users]="users"
              [selectedProject]="currentProject" [storyEstimates]="storyEstimates" [storyPriorities]="storyPriorities"
              [storyStatus]="storyStatus" [storyTypes]="storyTypes" [dashboard]="item.name"></casi-project-grid>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </div>

</div>

<div kendoWindowContainer></div>
